export default "__VITE_ASSET__C1Mv1UqK__"